export default __webpack_public_path__ + "static/media/merge.31175201.svg";